import {always} from 'ramda';
import React  from 'react';

const nop = always(true);
const ValidationContext = React.createContext({
  validate: nop,
  addValidator: nop,
  removeValidator: nop,
  showErrors: false
});
const {Provider, Consumer} = ValidationContext;

/** Creates a validation context that can be used to store and handle validators.
 *
 * returns an array of the form:
 * [validate, ValidationProvider]
 *
 * ValidationProvider is a component that provides a context for Validators
 * to hook on. The Validator component in this directory can use it
 * to register a validator in this context.
 * It takes one prop: showErrors, a boolean indicating whether to show errors
 *
 * validate runs all the registered validators and returns false if any of them
 * returns false
 */
export function createValidationContext() {
  const validators = new Set();

  function validate() {
    let valid = true;
    validators.forEach(validator => { if (!validator()) valid = false; });
    return valid;
  }

  function ProviderComponent({showErrors, children}) {
    const context = {
      addValidator: validators.add.bind(validators),
      removeValidator: validators.delete.bind(validators),
      validate,
      showErrors
    };
    return <Provider value={context} children={children} />;
  }

  return [validate, ProviderComponent];
}

export {Consumer as ValidationConsumer, ValidationContext};



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/validation/context.jsx